import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiCss3,
  DiGit,
  DiHtml5,
} from "react-icons/di";
import {
  SiRedux,
  SiExpress,
  SiBootstrap,
  SiChakraui,
  SiTailwindcss,
} from "react-icons/si";

import { TbBrandNextjs } from "react-icons/tb";
import { FaNpm } from "react-icons/fa";


function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiHtml5 />
        <h6>HTML</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiCss3 />
        <h6>CSS</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
        <h6>JAVASCRIPT</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiBootstrap />
        <h6>BOOTSTRAP</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiChakraui />
        <h6>CHAKRA UI</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTailwindcss />
        <h6>TAILWIND CSS</h6>
      </Col>
      {/* <Col xs={4} md={2} className="tech-icons">
        <SiMaterialui />
        <h6>MATERIAL UI</h6>
      </Col> */}
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
        <h6>REACT</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiRedux />
        <h6>REDUX</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
        <h6>NODE JS</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiExpress />
        <h6>EXPRESS JS</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb />
        <h6>MONGOO DB</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <TbBrandNextjs />
        <h6>NEXT JS</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
        <h6>GIT</h6>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaNpm />
        <h6>NPM</h6>
      </Col>      
    </Row>
  );
}

export default Techstack;
